import React, { useEffect, useState } from 'react'
import Breadcrumb from '../../../Components/Breadcrumbs'
import { Box, Divider, Grid, Typography } from '@material-ui/core'
import { useStyles } from './style'
import presentation from '../../../Assets/Images/presentation.svg'
import home from '../../../Assets/Images/home.svg'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import { ABOUTVPP, EXPLOREUSECASES } from './constant'
import { useScrollSpy } from '../../../Components/CustomHooks'

const items = [
  { hash: ABOUTVPP },
  // { hash: EXPLOREUSECASES },
]

function Introduction() {
  const classes = useStyles()
  const [active, setActive] = useState(window.location.hash.replace('#', ''))
  const activeSection = useScrollSpy({ items })

  const selectSection = (id) => {
    if (document.getElementById(id)) {
      document.getElementById(id).scrollIntoView({ behavior: "smooth" })
    }
  }

  useEffect(() => {
    if (activeSection) {
      setActive(activeSection)
    }
  }, [activeSection])

  useEffect(() => {
    if (active) {
      selectSection(active)
    }
  }, [])

  return (
    <>
      <Breadcrumb value={[{ 'Developer Hub': '/developer' }, { 'Introduction': '/developer/introduction' }]} />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>Introduction</Typography>
        <Box className={classes.subTitle}>All the guides and references you need to get started.</Box>
      </Box>
      <Box className={classes.cardWrapper}>
        <Grid container spacing={4}>
          <Grid item xs={10}>
            <Box className={classes.cardContent} id='scrollspy'>
              <Typography className={classes.cardTitle}>Introduction</Typography>
              <Box className={classes.cardDescription}>
                To make API requests, you’ll need an API key and the user_id of an Enlighten user (see below). To test-drive the API, you can use the user_id 4d7a45774e6a41320a. This is a special “demo” user for whom you can make API requests while you write and test your app.
              </Box>
              <Box className={classes.subCard} id="about-vpp">
                <Box display="flex" alignItems="center" px={2} pt={3} pb={2}>
                  <img src={presentation} className={classes.subCardImg} alt="" />
                  <Box className={classes.subCardTitle} mx={1}>
                    About VPP API
                  </Box>
                </Box>
                <Box mb={1}>
                  <Divider style={{ color: '#E1E1E1' }} />
                </Box>
                <Box className={classes.subCardContent} style={{ paddingBottom: '0px' }}>
                  <b>VPP API</b> is a JSON-based REST API secured with OAuth 2.0 authentication and authorization. The API is cloud-based with seamless onboarding and detailed swagger based documentation
                </Box>
                <Box className={classes.subCardContent}>
                  With VPP API, the following use cases are met:
                  <ul>
                    <li>Enroll Enphase systems into Grid Services programs</li>
                    <li>Group enrolled systems into Virtual Power Plants (VPPs)</li>
                    <li>Schedule discharge, charge, or idle events for either VPPs or Individual systems</li>
                    <li>Run events at a specific power setpoint for a set duration or till a target SOC</li>
                    <li>Supports independent, successive, overlapping, and nested events</li>
                    <li>Monitor systems and events telemetry with a 5-minute refresh and granularity</li>
                  </ul>
                </Box>
              </Box>
              {/* <Box className={classes.subCard} id="explore-usecases">
                <Box display="flex" alignItems="center" px={2} pt={3} pb={2}>
                  <img src={home} className={classes.subCardImg} alt="" />
                  <Box className={classes.subCardTitle} mx={1}>
                    Explore Use Cases
                  </Box>
                </Box>
                <Box mb={1}>
                  <Divider style={{ color: '#E1E1E1' }} />
                </Box>
                <Box className={classes.subHeading}>
                  Use Case 1
                </Box>
                <Box className={classes.subCardContent}>
                  <Box>
                    Name – Give your application a meaningful name and description. These will be presented to your users when you request access to their Enlighten systems, described below.
                  </Box>
                  <Box>
                    Description – A description of what your application does. Plan – Which plan you’ve chosen. You can upgrade or downgrade your usage limits here.
                  </Box>
                  <Box>
                    Status – Indicates whether your application can make API requests.
                  </Box>
                  <Box>
                    API Key – The value you’ll use in the “key” parameter when making API requests. Do not share this with anyone.
                  </Box>
                  <Box>
                    Developed By – An optional field indicating who wrote your application. If you develop mobile apps, for example, you should use the same name here as you do in the app stores where you publish.
                  </Box>
                  <Box>
                    Authorization URL – A link you’ll need to provide to your users so that they can grant your application access to their production data. Discussed in detail below.
                  </Box>
                </Box>
                <Box className={classes.subCardContent}>
                  <Box>
                    Name – Give your application a meaningful name and description. These will be presented to your users when you request access to their Enlighten systems, described below.
                  </Box>
                  <Box>
                    Description – A description of what your application does. Plan – Which plan you’ve chosen. You can upgrade or downgrade your usage limits here.
                  </Box>
                  <Box>
                    Status – Indicates whether your application can make API requests.
                  </Box>
                  <Box>
                    API Key – The value you’ll use in the “key” parameter when making API requests. Do not share this with anyone.
                  </Box>
                  <Box>
                    Developed By – An optional field indicating who wrote your application. If you develop mobile apps, for example, you should use the same name here as you do in the app stores where you publish.
                  </Box>
                  <Box>
                    Authorization URL – A link you’ll need to provide to your users so that they can grant your application access to their production data. Discussed in detail below.
                  </Box>
                </Box>
              </Box> */}
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box className={classes.scrollSpyContainer}>
              <>
                <Box className={classes.scrollSpyListText} pb={0.5}><b>On this page</b></Box>
                <Box id={ABOUTVPP} py={1} onClick={() => { setActive(ABOUTVPP); selectSection(ABOUTVPP) }} className={`${active === ABOUTVPP ? classes.currentSection : ''}`}><Link className={classes.scrollSpyListText} to={{ pathname: '/developer/introduction', hash: "#about-vpp" }} replace>About VPP API</Link></Box>
                {/* <Box id={EXPLOREUSECASES} py={1} onClick={() => { setActive(EXPLOREUSECASES); selectSection(EXPLOREUSECASES) }} className={`${active === EXPLOREUSECASES ? classes.currentSection : ''}`}><Link className={classes.scrollSpyListText} to={{ pathname: '/developer/introduction', hash: "#explore-usecases" }} replace>Explore Usecases</Link></Box> */}
              </>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default Introduction